import { render, staticRenderFns } from "./CourierEditDialog.vue?vue&type=template&id=351f403a&"
import script from "./CourierEditDialog.vue?vue&type=script&lang=ts&"
export * from "./CourierEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports